'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  // $urlRouterProvider.when("/", "/fonts/list");
  $urlRouterProvider.when("/fonts", "/fonts/list");
  $stateProvider
    .state('fonts', {
      url: '/fonts?page',
      template: require('./fonts.html'),
      authenticate: true
    })
    .state('fonts.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'FontsListController',
      controllerAs: 'fontsListCtrl'
    })
    .state('fonts.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'FontsEditController',
      controllerAs: 'fontsEditCtrl'
    })
    .state('fonts.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'FontsAddController',
      controllerAs: 'fontsAddCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/fonts/fonts.routes.js